import React, { Fragment, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './index';
import { IpeLocaleSwitcherFloat } from './IpeLocaleSwitcher';
import { IPE_UI_LOCALE_EVENT } from './locales';
import { getIpeUiLocale } from './storage';

function applyDocumentLang(locale) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = locale || 'zh-CN';
}

/** 全站界面语言。顶栏有挂点时按钮在顶栏，其余页面固定在右上角。 */
export default function IpeI18nProvider({ children }) {
  const [locale, setLocale] = useState(() => getIpeUiLocale());
  useEffect(() => {
    const sync = (event) => {
      const next = event?.detail?.locale || getIpeUiLocale();
      if (i18n.language !== next) {
        i18n.changeLanguage(next);
      }
      applyDocumentLang(next);
      setLocale(next);
    };
    sync();
    const onLanguageChanged = (next) => {
      applyDocumentLang(next);
      setLocale(next);
    };
    i18n.on('languageChanged', onLanguageChanged);
    window.addEventListener(IPE_UI_LOCALE_EVENT, sync);
    return () => {
      i18n.off('languageChanged', onLanguageChanged);
      window.removeEventListener(IPE_UI_LOCALE_EVENT, sync);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <LocaleRefresh locale={locale}>
        {children}
        <IpeLocaleSwitcherFloat />
      </LocaleRefresh>
    </I18nextProvider>
  );
}

function LocaleRefresh({ locale, children }) {
  return <Fragment key={locale}>{children}</Fragment>;
}
